import { Props } from "./Cocinas.type";
import { Loading } from "@/components/common/Loading";
import { Protected } from "@/components/layout/Protected";
import {  Box, Button, Container, createTheme, Divider, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, ThemeProvider, Typography, FormControlLabel, Switch } from "@mui/material";
import { esES } from "@mui/material/locale";
import { Popup } from "../Editor/components/Popup";
import ContentPasteOffIcon from '@mui/icons-material/ContentPasteOff';
import { PencilIcon } from "@/toolbox/constants/icons";
import DeleteIcon from '@mui/icons-material/Delete';
import React from "react";
import { ModalCocina } from "./components/ModalCocina";
import { cocinaService } from "@/service/services/Cocina.service";

const theme = createTheme(
    {
        palette: {
            primary: { main: '#1976D2' },
        },
    },
    esES,
);

export const Cocinas: React.FC<Props> = (props:Props):JSX.Element => {

    const [loading, setLoading] = React.useState<boolean>(false);
    const [openPopup, setOpenPopup] = React.useState<boolean>(false);
    const [editMode, setEditMode] = React.useState<boolean>(false);
    const [cocinaSelected, setCocinaSelected] = React.useState<any>('');

    const [cocinas, setCocinas] = React.useState([]);

    React.useEffect(() => {
        getCocinas();
        // eslint-disable-next-line
    }, []);

    const getCocinas = async() => {
        setLoading(true);
        await cocinaService.getCocinas().then((data) => {
            if(data.status === 200){
                setCocinas(data.cocinas);
            }else{
                setCocinas([]);
            }
            setLoading(false);
        })
    }

    const funcionSwitch = async (cocina)=>{
        setLoading(true);
        if(cocina.status === 1){
            await cocinaService.editStatus(cocina.id, 0);
        }else{
            await cocinaService.editStatus(cocina.id, 1);
        }
        getCocinas();
    }

    return (
        <Protected>
            {loading && <Loading/>}
            <Container maxWidth='xl' sx={{ mt: 1, mb: 2 }}>

                <Grid container justifyContent='space-between' spacing={2}>
                    <Grid item>
                        <Typography variant='h4' >Gestión de Cocinas</Typography>
                    </Grid>
                    <Grid item>
                        <Button variant='outlined' style={{textTransform: "capitalize"}}
                        onClick={()=>{
                            setOpenPopup(true);
                            setEditMode(true);
                        }}
                        >Crear nueva cocina</Button>
                    </Grid>
                </Grid>

                <Divider sx={{ mt: 2 }} />

                <Grid container spacing={1} >
                    <Grid item xs={12}>
                        <Typography variant="body2" sx={{ mt: '20px' }} >
                            {
                                (cocinas.length)  ? `${cocinas.length} registros encontrados`
                                    : `0` && !loading
                            }
                        </Typography>
                    </Grid>
                </Grid>

                <Grid>
                    {
                        cocinas.length > 0 && (
                            <Box sx={{Width: '100%', marginTop:'30px'}}>
                                <TableContainer component={Paper}>
                                    <ThemeProvider theme={theme}>
                                        <Table aria-label="simple table" size='small'>
                                            <TableHead>
                                                <TableRow  sx={{ bgcolor:'#1976D2'}}>
                                                    <TableCell sx={{ color: 'white' }} >
                                                        <strong>N°</strong>
                                                    </TableCell>
                                                    <TableCell align='left' sx={{ color: 'white' }} >
                                                        <strong>Nombre</strong>
                                                    </TableCell>
                                                    <TableCell align='center' sx={{ color: 'white' }} >
                                                        <strong>Habilitar / Deshabilitar</strong>
                                                    </TableCell>
                                                    <TableCell align='center' sx={{ color: 'white' }} >
                                                        <strong>Estado</strong>
                                                    </TableCell>
                                                    <TableCell align='center' sx={{ color: 'white' , minWidth:'8rem', maxWidth:'12rem'}}><strong>Acciones</strong></TableCell>
                                                </TableRow>
                                            </TableHead>

                                            <TableBody>
                                                {
                                                    cocinas.map((cocina, id) =>(
                                                        <TableRow key={id}>
                                                            <TableCell component="th" scope="row">
                                                                {id+1}
                                                            </TableCell>
                                                            <TableCell component="th" scope="row">
                                                            {cocina.name.charAt(0).toUpperCase() + cocina.name.slice(1).toLowerCase()}
                                                            </TableCell>
                                                            <TableCell align='center' component="th" scope="row">
                                                                <Box>
                                                                <FormControlLabel
                                                                    control={<Switch onClick={() => {
                                                                        funcionSwitch(cocina);
                                                                    }}
                                                                />}
                                                                checked={cocina.status === 1 ? true : false}
                                                                label=""
                                                                />
                                                                </Box>
                                                            </TableCell>
                                                            <TableCell align='center' component="th" scope="row">
                                                                {cocina.status === 1 ? 'Habilitada' : 'Deshabilitada'}
                                                            </TableCell>
                                                            <TableCell align='center'>
                                                                <Button
                                                                    onClick={() =>  {
                                                                        setOpenPopup(true);
                                                                        setEditMode(true);
                                                                        setCocinaSelected(cocina);
                                                                    }}
                                                                >
                                                                    <PencilIcon/>
                                                                </Button>
                                                                {/* <Button
                                                                    onClick={() =>  {
                                                                    }}
                                                                >
                                                                    <DeleteIcon style={{color: 'red'}}/>
                                                                </Button> */}
                                                            </TableCell>
                                                        </TableRow>
                                                    ))
                                                }
                                            </TableBody>
                                        </Table>
                                    </ThemeProvider>
                                </TableContainer>
                            </Box>
                        )
                    }
                    {
                        !loading && cocinas.length === 0 &&
                            <Grid container justifyContent="center">
                                <Box sx={{marginTop: '50px'}}>
                                <Grid container justifyContent="center"> <ContentPasteOffIcon className="iconocarrito"/></Grid>
                                    <Box sx={{Width: '100%', marginBottom:'30px', textAlign:'center'}}>No hay Cocinas registradas</Box>
                                </Box>
                            </Grid>

                    }
                    {loading && cocinas.length === 0 && 
                     <Box sx={{backgroundColor: 'rgba(224, 224, 224, 0.5)', padding: '15px', borderRadius: '10px', height:'100px'}}>
                     </Box>
                    }
                </Grid>

            </Container>
            {
                openPopup === true && (
                    <Popup
                    largo="md"
                    title = 'Registrar nueva Cocina'
                    openPopup = {openPopup}
                    setOpenPopup = {setOpenPopup}
                    >
                        <ModalCocina
                            closeModal={() => {setOpenPopup(false)}}
                            handleLoad={getCocinas}
                            cocinaSelected={cocinaSelected}
                        />
                    </Popup>
                )
            }
        </Protected>
    )
}